module.exports = __webpack_public_path__ + "media/images/TaslerIT_Logo_horiz_blk-55bf59b89b937fb4525014026b74eb02.svg";